import React from "react";
import { Card, MenuItem } from "@mui/material";

const TableMenuActions = ({
  handleClose,
  menuItems = [],
  rowData,
}) => {
  return (
    <Card style={{ padding: "0.7rem 0.4rem" }}>
      {menuItems.map(({ icon, text, handleClick, isDisabled }, index) => {
        return (
          <MenuItem
            className="d-flex py-2 text-sm"
            style={{ gap: "16px", fontWeight: 700 }}
            onClick={() => {
              handleClick(rowData);
              handleClose();
            }}
            key={index}
            disabled={isDisabled(rowData)}
          >
            {icon}
            <span>{text}</span>
          </MenuItem>
        );
      })}
    </Card>
  );
};

export default TableMenuActions;
